<template lang="html">

  <section class="faq">
    <div id="content">

        <div id="faq">
            <div class="titlebanner">
                <h3>FAQ</h3>
            </div>

            <div class="section">
                    <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapseOne">
                                                Dois-je obligatoirement avoir un site Internet ?
                                                </button>
                                            </h5>
                                            </div>
                                        
                                            <div id="collapse1" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                            <div class="card-body">
                                                Non, pour chaque événément créé, SkanTicket vous fournit un minisite. Ajoutez-y des images et tout ce dont vous avez besoin pour qu’il ressemble à votre événement !
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapseTwo">
                                                Puis-je intégrer la billetterie dans mon propre site web ?
                                                </button>
                                            </h5>
                                            </div>
                                            <div id="collapse2" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                            <div class="card-body">
                                                Oui, depuis votre « espace organi­sateur » personnel, exportez d’un simple copier-coller votre widget de billet­terie sur votre site. Cela ne demandera que quelques minutes à votre Webmaster.
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapseThree">
                                                Est-il possible d’organiser un événement multi-dates ?
                                                </button>
                                            </h5>
                                            </div>
                                            <div id="collapse3" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                            <div class="card-body">
                                                Bien sûr, vous organisez des tournées, des spectacles, des pièces de théâtre ou tout autre événement multi-date ? Notre outil vous permet de paramétrer en quelques clics la billet­terie en ligne des diffé­rentes séances de votre événement !
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse5" aria-expanded="false" aria-controls="collapseTwo">
                                                Quelles compétences sont requises pour vendre des billets en ligne ?
                                                </button>
                                            </h5>
                                            </div>
                                            <div id="collapse5" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                            <div class="card-body">
                                                Aucune, si vous savez utiliser un ordinateur. La configuration est simplifiée et se fait pas à pas en fonction de vos besoins.
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapse4" aria-expanded="true" aria-controls="collapseOne">
                                                Comment et quand reçoit-on les paiements ?
                                                </button>
                                            </h5>
                                            </div>
                                        
                                            <div id="collapse4" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                            <div class="card-body">
                                                Les 1er et 16 de chaque mois vous recevrez l'argent des ventes en ligne que vous avez déjà réalisé. L'argent vous est reversé par virement bancaire. Il est également possible de ne recevoir l'argent qu'après la fin de l'événement.
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse6" aria-expanded="false" aria-controls="collapseThree">
                                                Combien de temps dois-je attendre avant la mise en vente de mes billets ?
                                                </button>
                                            </h5>
                                            </div>
                                            <div id="collapse6" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                            <div class="card-body">
                                                Les billets peuvent être mis en ventes immédiatement.
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                        </div>
            </div>

        </div>

        <pied-creer-billetterie/>



    </div>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from '@/components/PiedCreerBilletterie'

  export default  {
    name: 'faq',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      PiedCreerBilletterie
    }
}
</script>

<style scoped>
</style>
